import OfferCard from './components/SellerOfferCard';

import { useEffect, useState } from 'react';
import { MdFormatListBulleted } from 'react-icons/md';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { useNavigate } from 'react-router-dom';
import { getImage } from 'variables/images';
import { useDisclosure } from '@chakra-ui/hooks';
import SuccessModal from './components/SuccessModal';
import KYCBanner from 'components/KYCBanner';

const MyOffer = () => {
    // const [offers, setOffers] = useState([]);
    const [user, setUser] = useState(null);
    const [myOffers, setMyOffers] = useState([]);
    const [filteredOffers, setFilteredOffers] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('all');
    const [searchQuery, setSearchQuery] = useState('');
    // Define status types with display names and values
    const statusTypes = [
        { value: 'all', label: 'Toutes' },
        { value: 'on_market', label: "En attente d'un acheteur" },
        { value: 'waiting_payment', label: 'En attente de paiement' },
        { value: 'running', label: 'En cours' },
        { value: 'done', label: 'Terminé' },
        // Add more types if needed
    ];
    const { isOpen, onOpen, onClose } = useDisclosure();
    const nav = useNavigate();

    const initUser = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res) => {
                const user = res.data;
                if (user.kyc_url) {
                    setTimeout(() => {
                        window.location.href = user.kyc_url;
                    }, 3000);
                }
                setUser(res.data);
                if (res.data && res.data.type !== 'seller') {
                    window.location.href = '/my-request';
                }
                console.log(res.data);
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const initMyOffer = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/seller-offer/mine`, config)
            .then((res) => {
                setMyOffers(res.data);
                setFilteredOffers(res.data);
                console.log(res.data);
            })
            .catch((err) => {
                console.log('No user info found', err);
                window.location.href = '/auth/sign-in';
            });
    };
    // Filter offers when selectedStatus changes or myOffers updates
    useEffect(() => {
        let offers = myOffers;
        if (selectedStatus !== 'all') {
            offers = offers.filter((offer) => offer.status === selectedStatus);
        }
        if (searchQuery.trim() !== '') {
            const query = searchQuery.trim().toLowerCase();
            offers = offers.filter(
                (offer) =>
                    (offer.subIndustry &&
                        offer.subIndustry.toLowerCase().includes(query)) ||
                    (offer.title && offer.title.toLowerCase().includes(query))
            );
        }
        setFilteredOffers(offers);
    }, [selectedStatus, myOffers, searchQuery]);

    useEffect(() => {
        if (
            !localStorage.getItem('token') ||
            localStorage.getItem('token').length < 10
        )
            window.location.href = '/auth/sign-up';

        const urlParams = new URLSearchParams(window.location.search);
        const created = urlParams.get('created');
        if (created === 'true' && !isOpen) {
            onOpen();
            const newUrl = window.location.pathname;
            window.history.replaceState({}, '', newUrl);
        }

        initMyOffer();
        initUser();
    }, [isOpen, onOpen]);

    return (
        <div className="flex flex-col gap-6">
            {/* Header */}
            <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
                <p className="font-geist text-xs font-semibold uppercase tracking-widest text-leadrs-text-soft">
                    Vendeur
                </p>
                <h1 className="mt-1 font-crimson text-4xl font-semibold leading-tight text-leadrs-text">
                    Mes offres
                </h1>
                <p className="mt-2 font-geist text-sm text-leadrs-text-soft">
                    Gerez vos propositions de leads et suivez leur evolution sur la plateforme.
                </p>
            </div>

            <KYCBanner user={user} onUserRefresh={initUser} />
            <SuccessModal isOpen={isOpen} onClose={onClose} />

            {/* Filters + action */}
            <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="flex flex-wrap items-center gap-2">
                    {statusTypes.map((type) => (
                        <button
                            key={type.value}
                            className={`rounded-lg border px-3 py-1.5 font-geist text-sm transition-colors ${
                                selectedStatus === type.value
                                    ? 'border-leadrs-brand bg-leadrs-brand text-white'
                                    : 'border-leadrs-stroke bg-white text-leadrs-text hover:border-leadrs-brand'
                            }`}
                            onClick={() => setSelectedStatus(type.value)}
                        >
                            {type.label}
                        </button>
                    ))}
                    <input
                        type="text"
                        className="rounded-lg border border-leadrs-stroke bg-white px-3 py-1.5 font-geist text-sm text-leadrs-text outline-none transition-colors focus:border-leadrs-brand md:w-56"
                        placeholder="Rechercher..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>
                <button
                    className="flex items-center gap-2 rounded-xl bg-leadrs-yellow-soft px-4 py-2.5 font-geist text-sm font-medium text-leadrs-yellow-focus hover:opacity-80 transition-opacity"
                    onClick={() => nav('/seller-offer')}
                >
                    <MdFormatListBulleted className="h-4 w-4 flex-shrink-0" />
                    Ajouter une offre
                </button>
            </div>

            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
                {filteredOffers.map((offer) => (
                    <OfferCard
                        key={offer._id}
                        channels={offer.channels}
                        offerNumber={offer.offerNumber}
                        title={offer.subIndustry}
                        author={offer.industry}
                        status={offer.status}
                        isArchived={offer.status === 'done'}
                        price={offer.buyerPrice}
                        weeklyQuantity={offer.weeklyQuantity}
                        image={getImage(offer.industry, offer.subIndustry)}
                        onClick={() => nav(`/offer/${offer._id}`)}
                    />
                ))}
            </div>

            {filteredOffers.length === 0 && (
                <div className="flex flex-col items-center gap-4 py-12">
                    <p className="font-geist text-sm text-leadrs-text-soft">
                        {myOffers.length === 0
                            ? "Vous n'avez pas encore d'offre."
                            : 'Aucune offre ne correspond a ce statut.'}
                    </p>
                    {myOffers.length === 0 && (
                        <button
                            className="rounded-lg bg-leadrs-brand px-6 py-2.5 font-geist text-sm font-medium text-white transition-opacity hover:opacity-80"
                            onClick={() => nav('/seller-offer')}
                        >
                            Creer ma premiere offre
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default MyOffer;
